import { RouterModule, Routes } from "@angular/router";
import { environment } from "@environments/environment";

import { OktaCallbackComponent } from "@components/okta-callback/okta-callback.component";
import { GuidedFlowEmptyComponent } from "@components/guided-flow/guided-flow-empty-component";
import { NgModule } from "@angular/core";
import { Auth0Guard } from "@services/authentication/auth0guard";
import { GuidedFlowComponent } from "@components/guided-flow/guided-flow.component";
import { RknAuthGuard } from "@weps/shared-http";

// For local testing, so we don't have to disable canActivate every time :^)
const isLocal: boolean = environment.deployment === "local";
const isInternal: boolean = environment.internal;
const dynamicGuard = isInternal ? RknAuthGuard : Auth0Guard;

export const routes: Routes = [
  { path: "login/callback", component: OktaCallbackComponent },
  { path: "guided-flow/:accountType/:step", component: GuidedFlowComponent },
  {
    path: "",
    canActivate: !isLocal ? [dynamicGuard] : [],
    children: [
      {
        path: "personal-wealth-inventory",
        title: "Personal Wealth Inventory",
        loadComponent: () =>
          import("@components/personal-wealth-inventory/personal-wealth-inventory.component").then(
            (c) => c.PersonalWealthInventoryComponent,
          ),
      },
      {
        path: "balance-sheet",
        redirectTo: "/personal-wealth-inventory",
        pathMatch: "full",
      },
      {
        path: "client-data",
        title: "Client Data Component",
        loadComponent: () =>
          import("./components/client-data/client-data.component").then(
            (c) => c.ClientDataComponent,
          ),
      },
      {
        path: "guided-flow",
        title: "Guided Flow Component",
        loadComponent: () =>
          import("./components/guided-flow/guided-flow.component").then(
            (c) => c.GuidedFlowComponent,
          ),
        children: [
          {
            path: ":accountType-:step",
            title: "Guided Flow Component",
            component: GuidedFlowEmptyComponent, // Use an empty component to preserve the same page
          },
        ],
      },
    ],
  },
  { path: "", redirectTo: "/", pathMatch: "full" },
  // TODO: When we get rid of the client-data page, uncomment this so that we redirect to PWI by default, even when people make mistakes typing in the URL. Also remove the path: "balance-sheet" match redirection as well
  // { path: "**", redirectTo: "/personal-wealth-inventory", pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Scrolls guided-flow pages to top when route changes
      // It works for PWI & Client Data pages as well BUT since we render the spinner first, it essentially doesn't work in the way we would expect
      // So we put it in the RobService -> getRobData function so that it'll trigger after the call to ROB finishes, the data comes back, and the page renders
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
